import { render, staticRenderFns } from "./nxSelectDealerArea.vue?vue&type=template&id=8e4d45d6&scoped=true&"
import script from "./nxSelectDealerArea.vue?vue&type=script&lang=js&"
export * from "./nxSelectDealerArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.10.1_sqwtrzbl6s4ypz4dmnoirtpj7i/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8e4d45d6",
  null
  
)

export default component.exports